import './IconPlus.css';
import React from 'react';
var IconPlus = function IconPlus(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: "".concat(className, " ").concat(styles)
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11 5v4h4v2h-4v4H9v-4.001L5 11V9l4-.001V5h2z"
  }));
};
var styles = "s18w4e2n";
export default IconPlus;